<template>
  <div class="news-information">
    <el-row>
      <el-col :span="24">
        <h1 class="news-title">新闻资讯</h1>
      </el-col>
    </el-row>
    <!-- 轮播区域开始 -->
    <div class="news-swiper-wrapper">
      <div class="custom-swiper">
        <div
          v-for="(newsItem, idx) in newsItems.slice(0, 3)"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
          @touchend="(e) => onTouchEnd(e, newsItem)"
          :key="newsItem.id"
          class="news-swiper-slide"
          :class="{
            center: idx === currentIndex,
            left: idx === leftIndex,
            right: idx === rightIndex,
          }"
          v-show="[leftIndex, currentIndex, rightIndex].includes(idx)"
        >
          <el-card shadow="hover" class="news-card" style="cursor: pointer">
            <!-- <img :src="(newsItem.img ? newsItem.img.split(',')[0] : '')" class="news-image" /> -->
            <img
              :src="getFirstImage(newsItem)"
              alt="news-image"
              class="news-image"
            />
            <!-- <button class="main-button" @click="goToNewsCenter(newsItem.id)" @touchstart.stop @touchmove.stop
              @touchend.stop>详情 ></button> -->
            <div class="news-content">
              <h3 class="news-item-title">{{ newsItem.title }}</h3>
              <!-- <p class="news-item-description" v-html="richContent(newsItem.content)"></p> -->
              <p class="news-item-description">
                {{ getPlainText(newsItem.content) }}
              </p>
              <!-- {{ newsItem.content }} -->
              <div class="news-meta">
                <span class="news-source"
                  >{{ newsItem.newspaper }} | {{ newsItem.time }}</span
                >
                <span class="news-views">浏览：{{ newsItem.pageView }}次</span>
              </div>
            </div>
          </el-card>
        </div>
        <!-- <div class="swiper-controls">
          <span class="swiper-arrow left" @click.stop="prevSlide">&#8592;</span>
          <span class="swiper-arrow right" @click.stop="nextSlide">&#8594;</span>
        </div> -->
        <!-- <div class="swiper-dots">
          <span
            v-for="(item, idx) in newsItems.slice(0, 3)"
            :key="item.id"
            :class="['dot', { active: idx === currentIndex }]"
            @click="goToSlide(idx)"
          ></span>
        </div> -->
      </div>
    </div>
    <!-- 轮播区域结束 -->
    <el-row>
      <el-col :span="24" class="view-more">
        <a href="/news_center">查看更多新闻 ></a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listByTYpe } from "@/api/news.js";
import { IMG_BASE_URL } from "@/utils/index.js";

export default {
  name: "NewsInformation",
  data() {
    return {
      news: [
        {
          id: 1,
          title: "变电站无人机自主巡视 “一览无遗”无死角",
          description:
            "油养京识备色太六北劳立北构得非响海求万织你况支计引土...",
          source: "华软动态",
          date: "2021-06-22 10:00:51",
          views: 2314,
          image: "https://hr2.chnsoft.com.cn/img/news1.png",
        },
        {
          id: 2,
          title: "人机结合巡视，保护电网安全无忧",
          description: "1月20日，国网河南检修公司郑州运维三班班长甘红庆在50...",
          source: "华软动态",
          date: "2021-06-22 10:00:51",
          views: 2314,
          image: "https://hr2.chnsoft.com.cn/img/news2.png",
        },
        {
          id: 3,
          title: "无人机航拍高空盘旋百余米 锁定隐蔽 违法现场",
          description:
            "“准备，起飞！”一架黑色无人机迅速升空，在百余米的高空...",
          source: "华软动态",
          date: "2021-06-22 10:00:51",
          views: 2314,
          image: "https://hr2.chnsoft.com.cn/img/news3.png",
        },
      ],
      newsItems: [],
      currentIndex: 0,
      timer: null,
      touchStartX: 0,
      touchEndX: 0,
    };
  },
  computed: {
    IMG_BASE_URL() {
      return IMG_BASE_URL;
    },
    leftIndex() {
      const len = this.newsItems.slice(0, 3).length;
      return (this.currentIndex - 1 + len) % len;
    },
    rightIndex() {
      const len = this.newsItems.slice(0, 3).length;
      return (this.currentIndex + 1) % len;
    },
  },
  methods: {
    getNews() {
      //分页查询新闻列表请求

      listByTYpe({ type: "" }).then((res) => {
        if (res) {
          this.newsItems = res.result;
        }
      });
    },
    goToNewsCenter(id) {
      // this.$router.push({path: '/news_center'});

      this.$router.push({
        path: "/news_detail_mobile",
        query: { source: id, tabLabel: "全部新闻" },
      });
    },
    richContent(data) {
      // 处理富文本内容，确保图片路径正确
      if (!data) return "";

      let content = data;

      // 处理转义的HTML标签
      content = content
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");

      // 处理vue-quill生成的富文本内容
      // 移除ql-container和ql-editor包装，但保留内部内容的class属性
      content = content.replace(
        /<div class="ql-container.*?>(.*?)<\/div>/gs,
        "$1",
      );
      content = content.replace(
        /<div class="ql-editor.*?>(.*?)<\/div>/gs,
        "$1",
      );

      // 处理特殊格式的图片标记，如 ![image.png](data:image/png;base64,...)
      content = content.replace(
        /!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/gi,
        '<img src="$2" alt="$1" class="news-content-image" />',
      );

      // 处理Markdown格式
      // 加粗
      content = content.replace(/\*\*(.*?)\*\*/gi, "<strong>$1</strong>");
      // 斜体
      content = content.replace(/\*(.*?)\*/gi, "<em>$1</em>");
      // 删除线
      content = content.replace(/~~(.*?)~~/gi, "<del>$1</del>");
      // 标题 - 支持#后面有或没有空格的情况
      content = content.replace(/^#{1}\s*(.*?)$/gm, "<h1>$1</h1>");
      content = content.replace(/^#{2}\s*(.*?)$/gm, "<h2>$1</h2>");
      content = content.replace(/^#{3}\s*(.*?)$/gm, "<h3>$1</h3>");
      // 无序列表
      content = content.replace(/^\*\s(.*?)$/gm, "<li>$1</li>");
      content = content.replace(/(<li>.*?<\/li>)/gs, "<ul>$1</ul>");
      // 有序列表
      content = content.replace(/^\d+\.\s(.*?)$/gm, "<li>$1</li>");
      content = content.replace(/(<li>.*?<\/li>)/gs, "<ol>$1</ol>");
      // 段落 - 保留原始的class属性
      content = content.replace(/^(?!<h|!<|\*|\d+\.)(.*?)$/gm, (match) => {
        // 检查是否已经有HTML标签
        if (/^<.*?>/.test(match)) {
          return match;
        }
        return "<p>" + match + "</p>";
      });

      // 将\n转换为<br>标签，实现换行效果
      content = content.replace(/\n/g, "<br>");

      // 如果存在IMG_BASE_URL，并且图片路径是相对路径，则拼接完整URL
      if (this.IMG_BASE_URL) {
        // 匹配<img>标签中的src属性，保留其他属性如class
        content = content.replace(
          /<img\s+(.*?)src="([^"]+)"(.*?)>/gi,
          (match, prefix, src, suffix) => {
            // 检查是否已经是完整URL或base64
            if (!/^https?:\/\//i.test(src) && !src.startsWith("data:")) {
              // 拼接完整URL
              return (
                "<img " +
                prefix +
                'src="' +
                this.IMG_BASE_URL +
                src +
                '"' +
                suffix +
                ">"
              );
            }
            return match;
          },
        );
      }

      return content;
    },
    getPlainText(content) {
      if (!content) return "";

      let plainText = content;

      // 移除HTML标签
      plainText = plainText.replace(/<[^>]+>/g, "");

      // 移除Markdown格式的图片
      plainText = plainText.replace(/!\[(.*?)\]\(([^)]+)\)/g, "");

      // 移除Markdown格式的其他标记
      plainText = plainText.replace(/[*_~`]/g, "");

      // 移除多余的空白字符
      plainText = plainText.trim();

      return plainText;
    },
    getFirstImage(news) {
      // 首先检查news.img字段是否有图片
      if (news.img && news.img.trim() !== "") {
        return news.img.split(",")[0];
      }

      // 如果没有，再从富文本中提取第一个图片
      const content = news.content;
      if (!content) return "";

      // 匹配<img>标签中的src属性
      const imgTagMatch = content.match(/<img\s+src="([^"]+)"/i);
      if (imgTagMatch && imgTagMatch[1]) {
        return imgTagMatch[1];
      }

      // 匹配Markdown格式的图片
      const markdownMatch = content.match(
        /!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/i,
      );
      if (markdownMatch && markdownMatch[2]) {
        return markdownMatch[2];
      }

      return "";
    },
    prevSlide() {
      const len = this.newsItems.slice(0, 3).length;
      this.currentIndex = (this.currentIndex - 1 + len) % len;
      this.restartAutoPlay();
    },
    nextSlide() {
      const len = this.newsItems.slice(0, 3).length;
      this.currentIndex = (this.currentIndex + 1) % len;
      this.restartAutoPlay();
    },
    goToSlide(idx) {
      this.currentIndex = idx;
      this.restartAutoPlay();
    },
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    restartAutoPlay() {
      this.stopAutoPlay();
      // this.startAutoPlay();
    },
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchEndX = this.touchStartX; // 初始化
    },
    onTouchMove(e) {
      this.touchEndX = e.touches[0].clientX;
    },
    onTouchEnd(e, newsItem) {
      const deltaX = this.touchEndX - this.touchStartX;

      // console.log(deltaX)
      // if (Math.abs(deltaX) > 30) { // 滑动距离阈值
      //   if (deltaX > 0) {
      //     this.prevSlide();
      //   } else {
      //     this.nextSlide();
      //   }
      // }
      if (Math.abs(deltaX) > 30) {
        // 滑动
        if (deltaX > 0) {
          this.prevSlide();
        } else {
          this.nextSlide();
        }
      } else if (Math.abs(deltaX) < 10 && newsItem) {
        // 认为是点击
        this.goToNewsCenter(newsItem.id);
      }
      // 重置
      this.touchStartX = 0;
      this.touchEndX = 0;
    },
  },
  mounted() {
    this.getNews();
    // this.startAutoPlay();
  },
  beforeDestroy() {
    this.stopAutoPlay();
  },
};
</script>

<style lang="scss" scoped>
.news-information {
  width: 100%;

  margin: 0 auto;
  text-align: center;
  /* padding: 16PX 0PX; */
}

.news-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 40px;
  color: #1e242a;
}

/* 新增swiper样式 */
.news-swiper-wrapper {
  width: 100%;
  margin: 0 auto 20px auto;
  overflow: visible;
}

.custom-swiper {
  position: relative;
  width: 100%;
  /* min-height: 200PX; */
  height: 191px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.news-swiper-slide {
  position: absolute;
  top: 0;
  bottom: 0;
  transition: all 0.3s;
  opacity: 0;
  pointer-events: none;
  z-index: 1;
  /* 默认隐藏 */
}

.news-swiper-slide.center {
  /* left: 20%; */
  /* width: 190PX; */
  width: calc(49% - 32px);
  opacity: 1;
  transform: scale(1);
  z-index: 3;
  pointer-events: auto;
  /* padding: 0px 16PX; */
}

.news-swiper-slide.left {
  left: 0;
  width: 26%;
  opacity: 1;
  transform: scale(1);
  z-index: 2;
  pointer-events: auto;
}

.news-swiper-slide.right {
  right: 0;
  width: 26%;
  opacity: 1;
  transform: scale(1);
  z-index: 2;
  pointer-events: auto;
}

/* 保证间距10PX */
.news-swiper-slide.center {
  /* margin: 0 16PX; */
}

.news-swiper-slide.left,
.news-swiper-slide.right {
  margin: 0px;
}

.swiper-controls {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 0;
  display: flex;
  justify-content: space-between;
  pointer-events: none;
}

.swiper-arrow {
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  pointer-events: auto;
  user-select: none;
}

.swiper-arrow.left {
  margin-left: 8px;
}

.swiper-arrow.right {
  margin-right: 8px;
}

.swiper-dots {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ccc;
  display: inline-block;
  cursor: pointer;
}

.dot.active {
  background: #1e242a;
}

.news-image {
  width: 100%;
  height: 120px;
  object-fit: cover;

  /* 添加圆角 */
  background-size: 100% 100%;
}

.left .news-image {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.right .news-image {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.center .news-image {
  border-radius: 8px;
}

.news-content {
  padding: 20px 0px;
  text-align: left;
}

.news-item-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-item-description {
  font-size: 12px;
  color: #1e242a;
  margin-bottom: 8px;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-meta {
  font-size: 10px;
  color: #999;
  /* display: flex;
  justify-content: space-between; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view-more {
  margin-top: 20px;
  margin-bottom: 40px;
}

.view-more a {
  text-decoration: none;
  color: #1e242a;
  font-size: 10px;
}

::v-deep .el-card {
  border: none;
}

.news-swiper-slide,
.news-swiper-slide.center,
.news-swiper-slide.left,
.news-swiper-slide.right {
  height: 191px;
}

::v-deep .el-card__body {
  padding: 0px;
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}

.main-button {
  position: absolute;
  left: 10px;
  top: 90px;
  background: #cccccc2e;
  width: 33px;
  height: 16px;
  line-height: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-size: 7px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
}

.main-button:hover {
  border-color: #0f6bf6;
  color: #0f6bf6;
}
::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>
